import React, { Fragment } from 'react';
import {
    BulkDeleteButton,
    Create,
    Datagrid,
    DateField,
    DeleteButton,
    Edit,
    EditButton,
    List,
    ListButton,
    maxLength,
    minLength,
    RefreshButton,
    ReferenceField,
    required,
    SaveButton,
    SelectInput,
    SimpleForm,
    ReferenceInput,
    TextField,
    TextInput,
    Toolbar,
    TopToolbar,
    usePermissions,
} from 'react-admin'
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
    },
});

const validateRequired = [required()];
const validateUserName = [required(), minLength(3), maxLength(64)];
const validateUserEmail = [required(), minLength(3), maxLength(32)];

const PostEditActions = ({ basePath }) => (
    <TopToolbar>
        <ListButton basePath={basePath} />
        <RefreshButton />
    </TopToolbar>
);

const CustomToolbar = props => (
    <Toolbar {...props} classes={useStyles()}>
        <SaveButton />
    </Toolbar>
);

const CodeBulkActionButtons = props => (
    <Fragment>
        <BulkDeleteButton {...props}/>
    </Fragment>
);

export const CustomDeleteButton = props => (
    <DeleteButton {...props} mutationMode="pessimistic" />
  );

export const UserList = props => {
    const { permissions } = usePermissions();
    return (
        <List {...props} bulkActionButtons={<CodeBulkActionButtons />}>
            <Datagrid rowClick="edit">
                <TextField label="User id" source="id" />
                <ReferenceField label="Partner ID" reference="Partner" source="partnerId">
                    <TextField source="name" />
                </ReferenceField>
                <TextField label="Name" source="name" />
                <TextField label="Email" source="email" />
                <DateField label="Date Created" source="dateCreated" showTime />
                <DateField label="Date Modified" source="dateModified" showTime />
                {permissions === "ADMIN" && <EditButton />}
            </Datagrid>
        </List>
    );
};

export const UserEdit = props => (
    <Edit actions={<PostEditActions />} {...props} >
        <SimpleForm toolbar={<CustomToolbar />}>
            <ReferenceInput
                label="Select Partner ID"
                source="partnerId"
                reference="Partner">
                <SelectInput optionText="name" validate={validateRequired} />
            </ReferenceInput>
            <TextInput
                label="User Name"
                source="name"
                validate={validateUserName}
            />
            <TextInput
                label="User Email"
                source="email"
                validate={validateUserEmail}
            />
        </SimpleForm>
    </Edit>
);

export const UserCreate = props => (
    <Create actions={<PostEditActions />} {...props}>
        <SimpleForm redirect="list">
            <ReferenceInput
                label="Select Partner ID"
                source="partnerId"
                reference="Partner">
                <SelectInput optionText="name" validate={validateRequired} />
            </ReferenceInput>
            <TextInput
                label="User Name"
                source="name"
                validate={validateUserName}
            />
            <TextInput
                label="User Email"
                source="email"
                validate={validateUserEmail}
            />
        </SimpleForm>
    </Create>
);